// extracted by mini-css-extract-plugin
export default {"cls1":"tsXJOXTXdaDCh3GVTs4X","cls2":"Q2iQ59DVOrtRCvwWuZCp tsXJOXTXdaDCh3GVTs4X","isTabletDown":"c93sECeVJhHsrtbYXNLk","isPhone":"r3j489k5CARyHt6TmsEw"};